import http from "@/http-common";

export default class AttachFileService {
	
	getList(_params) {
		//alert(JSON.stringify(_params));
		return http.get('/ma/attachfile', { params: _params}).then(res => res.data);
	}

	getDownload(_params) {
		return http.get('/ma/attachfile/download',{ params: _params, responseType: 'blob'}).then(res => res.data);
	}

	deleteList(_data) {
		return http.delete('/ma/attachfile', {data:JSON.stringify(_data)}).then(res => res.data)
	}

}